import { useTranslation } from 'react-i18next';

import InfoPurpleIcon from '@/shared/assets/info-purple.svg?react';

export const EmptyChartPlaceholder = () => {
  const { t: tChart } = useTranslation('chart');

  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="relative flex items-center justify-center">
          <div className="absolute size-14 rounded-full border border-white/30" />
          <InfoPurpleIcon className="relative size-10" />
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
          <div className="text-sm font-semibold text-white">
            {tChart('empty_state.title')}
          </div>
          <div className="max-w-[312px] text-xs text-white/80">
            {tChart('empty_state.description')}
          </div>
        </div>
      </div>
    </div>
  );
};
